import { cn } from '@/app_lib/utils/utils';
import { InfoIcon } from './InfoIcon';

interface DataPointProps {
  title: string;
  value?: string | number;
  bottomValue?: string;
  tooltip?: string;
  className?: string;
  side?: 'bottom' | 'left' | 'right' | 'top';
  align?: 'center' | 'end' | 'start';
}

export const DataPoint = ({ title, value, bottomValue, tooltip, align, side, className }: DataPointProps) => {
  return (
    <div className={cn('@2xl:border-none odd:border-r-2 border-neutrals-300', className)}>
      <div className='flex items-start @2xl:hidden gap-2'>
        <div className='uppercase font-graphik-condensed typography-body-graphik-small'>{title}</div>
        {tooltip && (
          <InfoIcon
            align={align}
            side={side}
            tooltip={tooltip}
          />
        )}
      </div>
      <div className='font-graphik-condensed typography-body-graphik font-semibold @2xl:typography-body-graphik-xlarge @2xl:font-semibold pb-1'>
        {value || ''}
      </div>
      {bottomValue && <div className='font-graphik-condensed typography-body-graphik-xsmall'>{bottomValue}</div>}
    </div>
  );
};
